import React, { useState, useEffect } from "react";
import "./login.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import InPlayer from "../backend/inplayer";
import Global from "../../global";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Loader from "../loader/loader";
import { sendOtp } from "../api/core";
//import User from "../../user";
import Cookies from "js-cookie";
import { setData } from "./logout";
import { setSetting, intializeSetting } from "../javascript/function";

const Register = (props) => {
  const rmail = useFormInput("");
  const rname = useFormInput("");
  const [rDOB, setRDOB] = useState(new Date());
  const [rPhone, setRPhone] = useState("");
  const rPassword = useFormInput("");
  const rRepPassword = useFormInput("");
  const [rCountry, setRCountry] = useState("");
  const [loading, setLoading] = useState(false);
  const watchHistory = [];
  const favourites = [];
  const setting = intializeSetting();
  const profile = {};

  let history = useHistory();

  useEffect(() => {
    if (InPlayer.Account.isAuthenticated()) {
      if (Global.LOGIN && Global.SUBSCRIPTION && !Global.OTP) {
        let path = "/" + props.match.params.AppId + "/premium";

        history.push(path);
      } else if (Global.LOGIN && !Global.SUBSCRIPTION && !Global.OTP) {
        let path = "/" + props.match.params.AppId + "/home";

        history.push(path);
      } else if (!Global.LOGIN && Global.SUBSCRIPTION && !Global.OTP) {
        let path = "/" + props.match.params.AppId + "/home";

        history.push(path);
      } else if (Global.LOGIN && Global.SUBSCRIPTION && Global.OTP) {
        let path = "/" + props.match.params.AppId + "/verify";

        history.push(path);
      } else if (Global.LOGIN && !Global.SUBSCRIPTION && Global.OTP) {
        let path = "/" + props.match.params.AppId + "/verify";

        history.push(path);
      } else if (!Global.LOGIN && Global.SUBSCRIPTION && Global.OTP) {
        let path = "/" + props.match.params.AppId + "/verify";

        history.push(path);
      } else {
      }
    }
  }, [props.match.params.AppId, history]);

  const signUp = (event) => {
    setLoading(true);
    event.preventDefault();
    InPlayer.Account.signUp({
      fullName: rname.value,
      email: rmail.value,
      password: rPassword.value,
      passwordConfirmation: rRepPassword.value,
      grantType: "password",
      clientId: Global.CLIENTID,
      type: "consumer",
      referrer: "http://localhost:3001",
      metadata: {
        country: rCountry,
        phoneNumber: rPhone,
        phone_verifed: false,
        watchHistory: JSON.stringify(watchHistory),
        favourites: JSON.stringify(favourites),
        gdpr: false,
        cookies: false,
        settings: JSON.stringify(setting),
        profiles: JSON.stringify(profile),
      },
    })
      .then((data) => {
        if (data.status === 201) {
          setLoading(false);
          toastr.success("Successfully Created", "Success");

          /*    User.EMAIL = rmail.value;
          User.NAME = rname.value;
          User.PHONE = rPhone;
          User.COUNTRY = rCountry;
          User.PHONE_VERIFIED = false; */
          Cookies.set("sm_ott_val", false, { expires: 2 });
          setData(
            JSON.stringify(favourites),
            JSON.stringify(watchHistory),
            props.match.params.AppId,
            false
          );
          setSetting(JSON.stringify(setting));

          if (Global.LOGIN && Global.SUBSCRIPTION && !Global.OTP) {
            let path = "/" + props.match.params.AppId + "/premium";

            window.location.href = path;
          } else if (Global.LOGIN && !Global.SUBSCRIPTION && !Global.OTP) {
            let path = "/" + props.match.params.AppId + "/home";

            window.location.href = path;
          } else if (!Global.LOGIN && Global.SUBSCRIPTION && !Global.OTP) {
            let path = "/" + props.match.params.AppId + "/home";

            window.location.href = path;
          } else if (Global.LOGIN && Global.SUBSCRIPTION && Global.OTP) {
            sendOtp(Global.OTPKey, rPhone, props.match.params.AppId, history);
          } else if (Global.LOGIN && !Global.SUBSCRIPTION && Global.OTP) {
            sendOtp(Global.OTPKey, rPhone, props.match.params.AppId, history);
          } else if (!Global.LOGIN && Global.SUBSCRIPTION && Global.OTP) {
            sendOtp(Global.OTPKey, rPhone, props.match.params.AppId, history);
          } else {
          }
        }
      })
      .catch((error) => {
        setLoading(false);

        toastr.error(
          error.response ? error.response.data.message : "Error in Registering",
          "Error"
        );
      });
  };
  const handlePhoneChange = (value, data) => {
    var cc = "" + data.countryCode;
    //
    setRPhone(value);
    setRCountry(cc);
  };

  if (loading) {
    return <Loader load={"Default"}></Loader>;
  } else {
    return (
      <section
        className="sign-in-page"
        style={{
          background: "url(/images/home/show-1.jpg) no-repeat scroll 0 0",
        }}
      >
        <div className="container">
          <div className="row justify-content-center align-items-center height-self-center">
            <div className="col-lg-7 col-md-12 align-self-center">
              <div className="sign-user_card ">
                <div className="sign-in-page-data">
                  <div className="sign-in-from w-100 m-auto">
                    <h3 className="mb-3 text-center">Create An Account</h3>
                    <form className="mt-4" onSubmit={signUp}>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>E-mail</label>
                            <input
                              type="email"
                              className="form-control mb-0"
                              id="rmail"
                              name="rmail"
                              placeholder="Enter email"
                              {...rmail}
                              autoComplete="off"
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Full Name</label>
                            <input
                              type="text"
                              className="form-control mb-0"
                              id="rname"
                              name="rname"
                              placeholder="Full Name"
                              {...rname}
                              autoComplete="off"
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="">
                            <label>Date of Birth</label>
                            <DatePicker
                              selected={rDOB}
                              onChange={(date) => setRDOB(date)}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Phone Number</label>
                            <PhoneInput
                              country={rCountry}
                              value={rPhone}
                              onChange={handlePhoneChange}
                              required
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Password</label>
                            <input
                              type="password"
                              className="form-control mb-0"
                              id="rPassword"
                              name="rPassword"
                              {...rPassword}
                              placeholder="Password"
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Repeat Password</label>
                            <input
                              type="password"
                              className="form-control mb-0"
                              id="rRepPassword"
                              name="rRepPassword"
                              {...rRepPassword}
                              placeholder="Password"
                              required
                            />
                          </div>
                        </div>
                      </div>
                      <div className="sign-info">
                        <button
                          type="submit"
                          className="btn btn-hover"
                          style={{ float: "right" }}
                        >
                          Sign Up
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
                <div style={{ paddingTop: "40px" }}></div>

                <div className="row text center" style={{ width: "100%" }}>
                  <div className="col-sm-12 mt-3">
                    <a href="#!" className="btn fb">
                      {" "}
                      <i
                        className="fa fa-facebook"
                        style={{ marginRight: "5px" }}
                      ></i>
                      Facebook
                    </a>
                  </div>
                  <div className="col-sm-12 mt-3 ">
                    <a href="#!" className="btn gog">
                      {" "}
                      <i
                        className="fa fa-google"
                        style={{ marginRight: "5px" }}
                      ></i>{" "}
                      Google
                    </a>
                  </div>
                </div>
                <div style={{ paddingTop: "20px" }}></div>
                <div className="mt-3">
                  <div className="d-flex justify-content-center links">
                    Already have an account?{" "}
                    <Link
                      to={"/" + props.match.params.AppId + "/login"}
                      className="text-primary ml-2"
                    >
                      Sign In
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
};
const useFormInput = (initialValue) => {
  const [value, setValue] = useState(initialValue);

  const handleChange = (e) => {
    setValue(e.target.value);
  };
  return {
    value,
    onChange: handleChange,
  };
};
export default Register;
